<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>用户组任务计划</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search" style="align-items: center;">
            <div style="margin: 10px 1vh 10px 0;">
                <el-button type="success" size="small" @click.native="addMethods">新增用户组任务</el-button>
            </div>
            <div style="margin-right: 2vh;">
                <el-input placeholder="请输入用户分组id" prefix-icon="el-icon-search" size="small" v-model="groupId"
                    @keyup.enter.native="Query"></el-input>
            </div>
            <div style="margin-right: 2vh;">
                <el-input placeholder="请输入用户组名" prefix-icon="el-icon-search" size="small" v-model="groupName"
                    @keyup.enter.native="Query"></el-input>
            </div>
            <div style="margin-right: 2vh;">
                <el-select v-model="monthValue" placeholder="请选择月份" size="small" clearable style="width: 220px;">
                    <el-option v-for="item in monthOptions" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </div>
            <div style="margin-right: 2vh;">
                <el-select v-model="quarterValue" placeholder="请选择季度" size="small" clearable style="width: 220px;">
                    <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </div>
            <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
            <div style="margin-left:20px;"> <el-button type="success" size="small"
                    @click.native="resetting">重置</el-button>
            </div>
        </div>
        <div class="list" style="margin-top: 20px;">
            <el-table :data="groupTaskList" style="width: 100%" size="mini" stripe :row-class-name="tableRowClassName">
                <el-table-column prop="id" label="id" width="50"></el-table-column>
                <el-table-column prop="task_name" label="任务组名"></el-table-column>
                <el-table-column prop="group_id" label="用户分组id"></el-table-column>
                <el-table-column prop="month" label="月份"></el-table-column>
                <el-table-column prop="quarterly" label="季度"></el-table-column>
                <el-table-column prop="begin_time" label="开始时间"></el-table-column>
                <el-table-column prop="end_time" label="结束时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="380">
                    <template slot-scope="scope">
                        <el-button size="mini" type="info"
                            @click="addUserTask(scope.$index, scope.row)">添加计划任务</el-button>
                        <el-button size="mini" type="primary"
                            @click="goToTaskData(scope.$index, scope.row)">跳转任务</el-button>
                        <el-button size="mini" type="success"
                            @click="putGroupTaskList(scope.$index, scope.row)">修改</el-button>
                        <el-button size="mini" type="danger"
                            @click="delGroupTaskList(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="提示" :visible.sync="dialogDelete" width="30%" center>
            <div style="text-align: center;font-size: 25px;">是否删除这条数据</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete = false">取 消</el-button>
                <el-button type="danger" @click="clickDelete">删 除</el-button>
            </span>
        </el-dialog>
        <!-- 添加 -->
        <el-dialog title="添加数据" :visible.sync="dialogAddData" top="3%">
            <div>
                <div class="search" style="align-items: center;">
                    <div style="margin-left: 20px;">
                        <el-input placeholder="请输入分组名" prefix-icon="el-icon-search" size="small" v-model="group_name"
                            @keyup.enter.native="QueryAdd"></el-input>
                    </div>
                    <div style="margin-left: 20px;"> <el-button type="primary" size="small"
                            @click.native="QueryAdd">查询</el-button>
                    </div>
                    <div style="margin-left:20px;"> <el-button type="success" size="small"
                            @click.native="resettingAdd">重置</el-button>
                    </div>

                </div>
                <div class="list" style="margin-top: 20px;min-height: 100px;margin-bottom: 20px;">
                    <el-table :data="allGrouping" style="width: 100%" size="mini" stripe
                        :row-class-name="tableRowClassName" max-height="300">
                        <el-table-column prop="id" label="分组id" width="100"></el-table-column>
                        <el-table-column prop="name" label="用户分组名" width="300"></el-table-column>
                        <el-table-column prop="description" label="用户分组描述" width="280"></el-table-column>
                        <el-table-column prop="created_at" label="用户分组创建时间"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="235">
                            <template slot-scope="scope">
                                <el-button type="success" @click="copyMethods(scope.$index, scope.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="用户分组id" :label-width="formLabelWidth" prop="gropu_id">
                    <el-input style="width: 200px;" v-model="addData.group_id">
                    </el-input>
                </el-form-item>
                <el-form-item label="用户组任务名" :label-width="formLabelWidth" prop="task_name">
                    <el-input style="width: 200px;" v-model="addData.task_name" autocomplete="off"
                        placeholder="请输入用户组任务名"></el-input>
                </el-form-item>
                <el-form-item label="季度" :label-width="formLabelWidth">
                    <el-select v-model="addData.quarterly" placeholder="请选择季度" clearable>
                        <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份" :label-width="formLabelWidth">
                    <el-select v-model="addData.month" placeholder="请选择月份" clearable>
                        <el-option v-for="item in monthOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间" :label-width="formLabelWidth">
                    <el-date-picker v-model="addData.begin_time" type="datetime" placeholder="请选择开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" :label-width="formLabelWidth">
                    <el-date-picker v-model="addData.end_time" type="datetime" placeholder="请选择结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改 -->
        <el-dialog title="修改用户组任务" :visible.sync="dialogEditData" width="50%">
            <el-form :model="editData" :rules="rules" ref="editData">
                <el-form-item label="用户分组id" :label-width="formLabelWidth">
                    <el-input style="width: 200px;" v-model="editData.group_id" :disabled="true">
                    </el-input>
                </el-form-item>
                <el-form-item label="用户组任务名" :label-width="formLabelWidth" prop="task_name">
                    <el-input style="width: 200px;" v-model="editData.task_name" autocomplete="off"
                        placeholder="请输入用户组任务名"></el-input>
                </el-form-item>
                <el-form-item label="季度" :label-width="formLabelWidth">
                    <el-select v-model="editData.quarterly" placeholder="请选择季度" clearable>
                        <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份" :label-width="formLabelWidth">
                    <el-select v-model="editData.month" placeholder="请选择月份" clearable>
                        <el-option v-for="item in monthOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间" :label-width="formLabelWidth">
                    <el-date-picker v-model="editData.begin_time" type="datetime" placeholder="请选择开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" :label-width="formLabelWidth">
                    <el-date-picker v-model="editData.end_time" type="datetime" placeholder="请选择结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogEdit">取消</el-button>
                <el-button type="primary" @click="submitFormEdit">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加任务到用户组" :visible.sync="dialogAddToUserGroup" width="40%" center>
            <el-form :model="addToUserGroupForm" :rules="addToUserGroupRules" ref="addToUserGroupForm">
                <el-form-item label="任务ID" prop="group_task_id">
                    <el-input v-model="addToUserGroupForm.group_task_id" disabled style="width: 200px;" />
                </el-form-item>
                <el-form-item label="计划组名称" prop="group_name">
                    <el-select v-model="addToUserGroupForm.group_name" placeholder="请选择计划组" style="width: 200px;">
                        <el-option v-for="(item, index) in groupOptions" :key="index" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="添加手指操">
                    <el-select v-model="addToUserGroupForm.add_finger" placeholder="是否每天添加手指操" style="width: 200px;">
                        <el-option v-for="item in taskOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 新增情绪任务选择（默认空） -->
                <el-form-item label="添加情绪任务">
                    <el-select v-model="addToUserGroupForm.add_emotion" placeholder="是否每天添加情绪任务" style="width: 200px;">
                        <el-option v-for="item in taskOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="submitAddToUserGroup">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            monthOptions: [
                { value: 1, label: '1月' },
                { value: 2, label: '2月' },
                { value: 3, label: '3月' },
                { value: 4, label: '4月' },
                { value: 5, label: '5月' },
                { value: 6, label: '6月' },
                { value: 7, label: '7月' },
                { value: 8, label: '8月' },
                { value: 9, label: '9月' },
                { value: 10, label: '10月' },
                { value: 11, label: '11月' },
                { value: 12, label: '12月' }
            ],
            quarterOptions: [
                { value: 1, label: '第一季度' },
                { value: 2, label: '第二季度' },
                { value: 3, label: '第三季度' },
                { value: 4, label: '第四季度' }
            ],
            formLabelWidth: '150px',
            pages: 1,
            limit: 10,
            groupTaskList: [],
            total: 0,
            group_id: '', // 分组id
            month: '', // 月
            quarterly: '', //季
            task_name: '',//用户任务组名
            dialogDelete: false, // 删除弹窗是否显示
            delData: {},
            findKey: '', // 查找的key
            dialogAddData: false, // 添加弹窗
            addData: {
                group_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            }, // 添加数据对象
            rules: {
                task_name: [
                    { required: true, message: '请输入用户组任务名', trigger: 'blur' }
                ],
                group_id: [
                    { required: true, message: '请输入用户分组id', trigger: 'blur' }
                ],
            },
            dialogEditData: false, // 修改弹窗
            editData: {
                id: 0, // 任务ID（必填）
                group_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            },
            searchType: '', // 查询类型（quarter/month）
            quarterValue: '', // 季度选中值
            monthValue: '', // 月份选中值
            groupName: '', // 查询分组名称
            groupId: '', // 查询分组id
            allGrouping: [], // 添加分组任务的获取
            group_name: '', // 添加查询时候的组名
            dialogAddToUserGroup: false,
            addToUserGroupForm: {
                group_task_id: '',
                group_name: '',
                add_finger: null,  // 是否添加手指操任务
                add_emotion: null  // 是否添加情绪任务
            },
            addToUserGroupRules: {
                group_name: [
                    { required: true, message: '请选择计划组名称', trigger: 'change' }
                ]
            },
            groupOptions: [
                { value: 'SCD/MCI组', label: 'SCD/MCI组' },
                { value: '轻度痴呆组', label: '轻度痴呆组' },
                { value: '中度痴呆组', label: '中度痴呆组' }
            ],
            taskOptions: [
                { value: true, label: '是' },
                { value: false, label: '否' },
            ],
        }
    },
    created() {
        this.getGroupTaskList()
    },
    methods: {
        Query() {
            this.pages = 1;
            this.getGroupTaskList();
        },
        resetting() {
            this.group_id = '';
            this.task_name = '';
            this.searchType = '';
            this.quarterValue = '';
            this.monthValue = '';
            this.getGroupTaskList();
        },
        handleSearchTypeChange() {
            if (this.searchType === 'quarter') {
                this.monthValue = ''; // 切换到季度时清空月份
            } else {
                this.quarterValue = ''; // 切换到月份时清空季度
            }
        },
        handleSizeChange(val) {
            console.log(val)
            this.limit = val;
            this.getGroupTaskList()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getGroupTaskList()
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        // 获取
        getGroupTaskList() {
            // 构建基础参数对象
            const params = {
                pages: this.pages,
                limit: this.limit,
                group_id: this.groupId,
                task_name: this.groupName,
                quarterly: this.quarterValue,
                month: this.monthValue
            };

            // 过滤掉值为 null、undefined 或空字符串的参数
            const filteredParams = Object.entries(params)
                .filter(([_, value]) => value !== null && value !== undefined && value !== '')
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');

            this.$get(`/v1/admin/group-task?${filteredParams}`, {}).then((res) => {
                console.log(res);
                if (res.data.status !== 'success') {
                    this.$msg(res.data.msg);
                } else {
                    const resultData = res.data;
                    this.total = resultData.total;
                    this.groupTaskList = resultData.data;
                    console.log(resultData.data);
                }
            });
        },
        // 删除用户组任务
        delGroupTaskList(index, row) {
            this.dialogDelete = true
            this.delData = row
        },
        clickDelete() {
            this.$delete(`/v1/admin/group-task?group_task_id=${this.delData.id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('删除成功')
                    this.getGroupTaskList()
                    this.dialogDelete = false
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        // 添加相关
        addMethods() {
            this.getAllGrouping()
            this.dialogAddData = true
        },
        getAllGrouping() {
            this.$get(`/v1/admin/groups?group_name=${this.group_name}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.allGrouping = res.data.data
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        copyMethods(index, row) {
            this.addData.group_id = Number(row.id);
        },
        QueryAdd() {
            this.getAllGrouping(); // 使用选择的日期发起请求
        },
        resettingAdd() {
            this.group_name = ''
            this.getAllGrouping()
        },
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    // 开始时间和结束时间校验（可选）
                    if (this.addData.begin_time && this.addData.end_time &&
                        new Date(this.addData.begin_time) >= new Date(this.addData.end_time)) {
                        this.$message.error('开始时间必须早于结束时间');
                        return;
                    }
                    this.addTaskList(this.addData);
                }
            });
        },
        addTaskList(info) {
            let apiData = {
                group_id: info.group_id,
                task_name: info.task_name
            };

            if (info.quarterly) apiData.quarterly = info.quarterly;
            if (info.month) apiData.month = info.month;
            if (info.begin_time) apiData.begin_time = info.begin_time;
            if (info.end_time) apiData.end_time = info.end_time;
            console.log(apiData, 'apiData')
            this.$post(`/v1/admin/group-task`, apiData).then((res) => {
                console.log(res, 'resres')
                if (res.data.status === 'success') {
                    this.$message.success(res.data.msg)
                    this.getGroupTaskList()
                    this.closeDialogAdd()
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        // 重置表单优化
        closeDialogAdd() {
            this.dialogAddData = false;
            this.$refs.addData.resetFields();
            let newArrddData = {
                group_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            }
            this.addData = newArrddData
        },
        // 修改相关
        putGroupTaskList(index, row) {
            const handleEmptyValue = (value) => {
                return value === 0 || value === null ? '' : value;
            };
            this.editData = {
                ...row,
                quarterly: handleEmptyValue(row.quarterly), // 处理季度
                month: handleEmptyValue(row.month), // 处理月份
                begin_time: row.begin_time || '',
                end_time: row.end_time || ''
            };
            this.dialogEditData = true;
        },
        submitFormEdit() {
            this.$refs.editData.validate((valid) => {
                if (valid) {
                    const apiData = {
                        group_task_id: this.editData.id,
                        group_id: this.editData.group_id,
                        task_name: this.editData.task_name
                    };
                    if (this.editData.quarterly !== '') apiData.quarterly = this.editData.quarterly;
                    if (this.editData.month !== '') apiData.month = this.editData.month;
                    if (this.editData.begin_time !== '') apiData.begin_time = this.editData.begin_time;
                    if (this.editData.end_time !== '') apiData.end_time = this.editData.end_time;
                    console.log(apiData)
                    this.$put(`/v1/admin/group-task`, apiData).then((res) => {
                        console.log(res, 'resres')
                        if (res.data.status === 'success') {
                            this.$message.success(res.data.msg)
                            this.getGroupTaskList()
                            this.closeDialogEdit()
                        } else {
                            this.$msg(res.data.msg)
                        }
                    });
                }
            });
        },
        closeDialogEdit() {
            this.dialogEditData = false;
            this.$refs.editData.resetFields();
            this.editData = {
                id: 0,
                group_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            };
        },
        goToTaskData(index, row) {
            console.log(index, row, '----------')
            this.$router.push({
                path: '/taskData',
                query: {
                    groupTaskId: row.id,
                }
            });
        },
        addUserTask(index, row) {
            console.log(row, 'row')
            // 打开弹窗并设置group_task_id
            this.addToUserGroupForm.group_task_id = row.id;
            this.dialogAddToUserGroup = true;
        },

        // 提交添加到用户/用户组表单
        submitAddToUserGroup() {
            this.$refs.addToUserGroupForm.validate((valid) => {
                if (valid) {
                    // 构建请求参数
                    const apiData = {
                        group_name: this.addToUserGroupForm.group_name,
                        group_task_id: this.addToUserGroupForm.group_task_id,
                        add_finger: this.addToUserGroupForm.add_finger,
                        add_emotion: this.addToUserGroupForm.add_emotion
                    };

                    // 调用API
                    this.$post(`/v1/admin/add-task-to-user-or-group`, apiData).then((res) => {
                        if (res.data.status === 'success') {
                            this.$message.success(res.data.msg);
                            this.dialogAddToUserGroup = false;
                            this.resetAddToUserGroupForm(); // 清空表单
                        } else {
                            this.$msg(res.data.msg);
                        }
                    });
                }
            });
        },

        // 处理取消操作
        handleCancel() {
            this.resetAddToUserGroupForm(); // 清空表单
            this.dialogAddToUserGroup = false;
        },

        // 重置添加到用户/用户组表单
        resetAddToUserGroupForm() {
            this.addToUserGroupForm = {
                group_task_id: this.addToUserGroupForm.group_task_id, // 保留group_task_id
                group_name: '', // 清空group_name
                add_finger: null,  // 重置为空值
                add_emotion: null
            };
            // 或者使用表单重置方法
            this.$nextTick(() => {
                this.$refs.addToUserGroupForm && this.$refs.addToUserGroupForm.clearValidate();
            });
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.flex_box{
    margin: 12px;
    text-align right
}

.flex_box div {
    margin 10px
}

.right_box div {
    margin 10px
}
.right_box{
    color: red;
}

.dialog_style{
    display flex
    align-items center
    justify-content center
    font-size 19px
    color #000
}

   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        flex-wrap wrap
        align-items center
        justify-content flex-start
        input
          margin-right 10px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>
<style scoped>
.custom-content {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 100px;
    line-height: normal;
}
</style>


// WEBPACK FOOTER //
// src/pages/user_task_list/user_group_task/user_group_task.vue